{
    "login": {
        "title": "Авторизация",
        "emailLbl": "Email*",
        "passwordLbl": "Пароль*",
        "forgotPasswordLbl": "Забули пароль?",
        "registrationLbl": "Ще не зареєстровані? <a>Реєстрація</a>",
        "signIn": "Увійти"
    },
    "signUp": {
        "title": "Реєстрація",
        "submitBtn": "Зареєструватись",
        "confirmPasswordLbl": "Повторіть пароль*",
        "firstNameLbl": "Імя*",
        "lastNameLbl": "Прізвище*",
        "phoneNumberLbl": "Телефон",
        "companyNameLbl": "Назва компанії",
        "companyNamePlaceholder": "Введіть назву компанії",
        "countryLbl": "Країна",
        "addressLbl": "Адреса",
        "addressPlaceholder": "Введіть адресу",
        "zipLbl": "Індекс",
        "zipPlaceholder": "Введіть індекс",
        "cityLbl": "Місто",
        "cityPlaceholder": "Введіть місто",
        "companyStatus": "Статус",
        "defaultCompany": "Основна компанія",
        "tinLbl": "ІПН",
        "deliveryEstimate": {
            "title": "Ваші приблизні місячні поставки?",
            "lessThan5Name": "<5",
            "from5To20Name": "5-20",
            "from21To50Name": "21-50",
            "moreThan50Name": "> 50"
        },
        "consent": "Я даю згоду на обробку моїх персональних даних згідно з <a>Правила та умови</a> і прийняти це. Ви також в курсі і згодні <b>Політика файлів cookie</b>"
    },
    "confirmEmail": {
        "successAlert": "Перевірка успішна, тепер ви можете увійти.",
        "errorAlert": "Підтвердження не вдалося, ви також можете підтвердити свій обліковий запис за допомогою сторінки забули пароль."
    },
    "goToLogin": "Перейдіть до входу",
    "alert": {
        "checkEmail1": "Ми надіслали код вам на email,",
        "checkEmail2": "перевірте свою пошту",
        "changePasswordTitle": "Пароль змінений",
        "changePasswordContent1": "Тепер ви можете увійти до свого облікового ",
        "changePasswordContent2": "запису з новим паролем"
    },
    "forgotPassword": {
        "title": "Відновлення паролю",
        "content": "Введіть свій email для відновлення пароля"
    },
    "changePassword": {
        "title": "Змінити пароль",
        "description": "Щоб змінити пароль, введіть свій поточний пароль, а потім створіть новий.",
        "currentPassword": "Поточний пароль",
        "newPassword": "Новий пароль",
        "confirmNewPassword": "Підтвердіть новий пароль",
        "content": "Введіть та підтвердіть новий пароль",
        "sendBtn": "Оновити пароль",
        "changePasswordBtn": "Змінити пароль"
    }
}